/**
 * True when iAdvocate is running as an installed app (added to the home
 * screen / installed from the browser) rather than in a browser tab.
 *
 * `display-mode: standalone` is the standard signal (Chrome, Edge, Android,
 * iOS 16.4+); `navigator.standalone` is Safari's older iOS-only flag, still
 * the only one older iPhones set.
 */
export function isInstalledApp(): boolean {
  if (typeof window === 'undefined') return false;
  const standaloneMedia =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(display-mode: standalone)').matches;
  const iosStandalone =
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
  return standaloneMedia || iosStandalone;
}
